import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslations } from "next-intl";
import { PlatformLoginForm } from "@/components/platform-admin/platform-login-form";

/** MT-1 AUTH-009 `/platform/login` (FR-6.6): the platform console's own sign-in, no school. */
export function PlatformLoginPage() {
  const t = useTranslations("platformAuth");
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const reason = params.get("reason");
  return (
    <main className="mx-auto flex min-h-screen max-w-md flex-col justify-center px-4">
      <h1 className="mb-2 text-2xl font-semibold">{t("loginTitle")}</h1>
      <p className="mb-6 text-sm text-[var(--text-muted)]">{t("loginIntro")}</p>
      {reason === "idle" && (
        <p role="status" className="mb-4 text-sm" data-testid="platform-login-idle">
          {t("idleNotice")}
        </p>
      )}
      {params.get("password") === "set" && (
        <p role="status" className="mb-4 text-sm" data-testid="platform-login-password-set">
          {t("passwordSetNotice")}
        </p>
      )}
      <PlatformLoginForm onSignedIn={() => navigate("/platform/admin", { replace: true })} />
    </main>
  );
}
